module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i', [_vm._v("Chapter Two")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("GUY DE BAIS FOLLOWED FULK AND THE two knights carrying the Lady Alwyn up the narrow tower stairs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It is a bad thing not to have a wedding feast,” he commiserated, “but the fact is, there is not even bread to be had in the castle. This chamberlain, one Bedystyr, took the plate, flour, salt, and meat, and all that there was to drink, and melted away like a mist. There were not even pony tracks to follow in these cursed hills.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Geoffrey’s knights carried Lady Alwyn like hunters with a trussed deer. They deftly flipped her on her side as the staircase wound to the second story. Fulk stepped down a step to avoid being hit by her feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“As we stormed the keep, this supposedly trusted steward then deserted the Lady Alwyn, leaving only the guard in the tower and a few of the thieving Welsh to protect her.” De Bais was full of scorn for the Bretons, whom he felt were inferior to even the Saxons. “Fulk, I did not tell you this before, but we discovered sickness in the wards among the castle guard, which naturally they did not tell us at first, thinking perhaps to test us with the plague. But Geoffrey de Bocage sent them to the village, heedless of it, and burned their beds and the straw.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“In there,” Fulk told the knights. He bent his head at the low lintel as he entered the tower room. It too was freezing cold, but had a bed with tapestry hangings. “The Lady Alwyn was hiding in here?” he said, eyeing the bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hiding? Oh, no. At first we thought she was one of the Welsh, as she was dressed plainly and running about throwing stones with the wild serving maids and urging them on against us. Such behavior was not what we expected from the daughter of a Norman knight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Lesneven was a Breton,” Fulk told him. “One of William’s early allies. You said the daughter is half Welsh.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The young knight considered this. “There was a dog too, of the type they use to hunt wolves here in the marches, running with the women. A fearsome beast that sought to attack everything in its path. It was hard to manage the horses in such a wild fray.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Women and wild dogs, Fulk thought. The storming of Castle Morlaix did not sound like a battle de Bais and his cousin could boast of. He stepped aside to let the knights carry the girl to the bed. Fulk heard her groan. He would not untie her, he told himself, until he had time to deal with her. If there was any water at all in Castle Morlaix, he wanted a bath. Steaming hot. He needed to know if his sore, frozen limbs could be restored to life, or if the condition was permanent.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("De Bais looked dismayed. “A hot bath? Fulk, have you not heard what I’ve been telling you? Castle Morlaix is a pigsty, neglected all during the revolt. The Welsh run in and out of it like rats in a cheese. Look about you.” He gestured indignantly. “The old baron had not even finished the outer wall. Does King William know how it is?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("If William knew the condition of Castle Morlaix, he’d not told Fulk of it. "), _c('i', [_vm._v("My miraculous good fortune,")]), _vm._v(" he thought as he looked around the stone bedchamber. With hard work, and building onto the castle, which could perhaps be paid for by a levy settled on the Welsh, he supposed he could bring the fort up to what the king wanted of it. It would take years.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk pulled up a stool and sat down on it. Sweet Jesu, what a rat’s nest. And this was King William’s grant to him. The girl, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Aloud, he shouted, “Will you see to a fire here?” Geoffrey de Bocage had come in. Fulk indicated the two knights who had carried the girl with a jerk of his head. “Get them to hauling water before I perish of cold. And send up my squire. I want out of these stinking wet clothes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He saw the two knights stare at each other. Fighting men disliked what they considered base work; even the squires were slow to fetch and carry unless one drove them to it. Lofty Norman pride had increased by leaps and bounds now that England was under the Conqueror’s heel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Or considered to be so. The Bretons’ revolt should have shaken them all, Fulk was thinking, as he bent his head and began to work at the lacings under his arms. Not to mention the ever-seething Welsh. Normans had still much to learn. As he’d found during his stay at William’s court.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And fetch me something to eat.” If he didn’t get fed, he would not be able to face the night’s marital chores. “Raid the village, if that is what it takes, or storm the nearest Welsh fort. But beer or wine, at the least, if you can find no food.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("De Bais darted forward to push Fulk’s hands away from the fastenings. “Let me do it, Fu—milord.” The two knights, galvanized by shouts from Geoffrey, clattered down the stairs to fetch the bath and search for something to put in Fulk’s stomach.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His cousin came to kneel by Fulk’s stool. “I know where the stores have gone. There’s a local nuisance named Powys who leads the Welsh brigands hereabouts. They think him a military leader.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk squinted at him as de Bais inched the heavy mail shirt toward his face. “And the missing chamberlain?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Carried all castle stores to the Welsh rebel, including the plate, such as it was, and Lesneven’s treasury. Did they not tell us in London that here in the borders there is a Welsh traitor in every bed? Apparently there is one in every pantry, too.” Geoffrey eyed Fulk’s bare upper body as de Bais peeled away the padded undershirt. “Sweet Mary, I had not seen the new wound. If you were not built like a horse, Fulk, you would be all scar. Who dealt you such a blow?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk put his arms over his head and stretched. His cousin never forgot the three inches of height that overtopped him, nor Fulk’s strength. Geoffrey had never won a practice bout against him, though he’d tried desperately. Now, Fulk realized, not looking at him, Geoffrey had even more to envy: Castle Morlaix and the title of baron that William had bestowed. Perhaps even Lesneven’s daughter, through whom all this was accomplished, who was now waiting for him in the curtained bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk planned shortly to give Geoffrey a place to advance his ambition. But not soldiering with him in the field.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Find the butler and hang him,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Fulk, we go to Chirk on the morrow,” Geoffrey pointed\nout. “Do I chase Welsh butlers here, or the rebels in Chirk?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk realized he’d lost track of time. Half a day and time to sleep here at Morlaix was all he had. It was to be a damned short marital bedding. He stood up so that de Bais could strip away the mail chausses and the padding under them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Guy de Bais stepped back to view Fulk with mock awe. “Man, there is nothing small to you. The talk in the castle began the moment you entered the gates. A bull for a heifer. And pity the poor heifer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Geoffrey looked sly. “She’s surpassing old for a heifer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The other knight snickered. “But not yet a cow; we must leave that to Fulk.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was the sort of wit associated with weddings, but Fulk turned a cold eye on them. “You speak of my wife. If I am your liege lord, the woman is your liege lady.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("De Bais reddened. “Fulk—"), _c('i', [_vm._v("milord")]), _vm._v(", it was meant in jest.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hastily, he went to the room’s ransacked wardrobe for something to put about Fulk’s bare shoulders.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Geoffrey got up from his crouch by Fulk’s stool, sword and mail jingling. “I am no expert on virgins, but I have found they weep torrents when they are bedded, bleed copiously, complain bitterly. But recover miraculously at the word ‘marriage.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk refused to be baited. “Then I shall have no trouble, as marriage has already been accomplished.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("De Bais cast them an apprehensive look, but at that moment the squire entered the room with an armful of wood. Fulk took the low stool again, although his temper was not improved by sitting naked in the frigid air. It further drained his patience to hear de Bais shout the knights into hurrying with the tub and the water.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Aubrey had found a white woolen tunic somewhere below. He threw it about Fulk’s shoulders. An iron kettle had also been located, but it was so large it took four knights to drag it up the stairs, and it stuck between the walls midway. The cursing and running for more knights to work the kettle free wore on Fulk’s nerves. He sat with his shoulders hunched, waiting for the hot water that was eventually brought by knights running up and down the stairs with much clamor, perhaps to demonstrate they were not lowly fetchers and carriers. By the time Fulk eased himself into the bath the water was tepid, not hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He sank into it with a fervent groan, nevertheless. The wound that Geoffrey had remarked on had been gotten in France the past year, a reminder that with some Christian knights of King Phillip it was still wise to protect one’s back. The fire leaped, sending out warmth on his shoulders. As he soaked in the warmish water, Aubrey brought in a flacon of beer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk’s eyebrows went up. “Where did you find this?” He sipped the yeasty-tasting brew cautiously, then grimaced. “Well, it could be worse.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The young squire smiled. “I traded for it, Fulk. From a maid I found here in the castle.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk gave a sudden bellow of laughter that made him feel better. A young maid and Aubrey? The knights tormented the boy constantly. “Don’t tell me what you offered for it. Did she accept?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The squire’s face turned crimson. “Milord,” he murmured, eyes downcast.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk poured himself more beer. Some of the soreness was soaking out of him. He had time to contemplate the strange turn of fate that had brought him where he was. A dispute about a wedding, no less.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That sullen hothead, Roger of Hereford, already excommunicated by Bishop Lanfranc for his insolence to the king, had wanted to marry his sister Emma to Ralph of Wader, the Breton-English Earl of Norfolk. The king had forbidden it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It did not matter to William that the young Earl of Hereford and his sister were the children of William Fitz-Osbern, to whom William owed much. And that Ralph of Wader had been of indispensable service in helping William beat off an invasion of the Danish fleet. William did not want the two young earls, landholders and powerful in their own right, allying so closely through marriage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But while William was in Normandy, de Wader had married Emma anyway. Fitz-Osbern and de Wader then had held a great wedding feast in Exning, in Cambridgeshire, inviting not only the restless Bretons of Wader’s camp but also the Saxon prince Waltheof, and most of the north.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The English were there in great numbers, nobles, bishops, even Welsh chieftains. Drink was served, tongues went wagging, and reckless Hereford delivered himself of a speech, saying that in refusing to agree to the marriage of his sister to Ralph de Wader, Earl of Norfolk, William had insulted his dead father, Fitz-Osbern, to whom William owed the success of the great invasion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk had heard the stories of some of those who had been at Exning. All agreed Hereford’s and Wader’s madness had spread like wildfire. Someone among the English had cried that William was but a bastard and his claims to England were based on the poison deaths of those who opposed him, like Conan, Biota, and brave Walter. But the greatest complaint was that William had not lived up to his promises to the men who had fought his battles—that he had given them only war-ruined lands that the sycophants who surrounded the king in London did not want.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The wedding feast had broken up with the Saxon prince, Waltheof, pledged to the insurrection, Roger of Hereford departing to call up his army, and Ralph of Wader to assemble the Bretons and other Norman-hating troops.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("No wonder, Fulk thought wryly as he stepped out of the iron bath pot, that William was testy about marriages. If nothing else, the Fitz-Osbern–Wader wedding had brought him a war.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Warm with the fire and, for the first time that day not frozen or aching, he stood while Aubrey dried him off with a woolen blanket that still smelled of horses.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Leave it,” Fulk told him as the squire started to call for more knights to remove the kettle. He gave the boy a pat on the back. “Get to bed. I’ll tend to it later.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("God in heaven but he wanted his own rest, he thought. Not able to hold back a yawn, he went to the bed and looked down at his bride.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("If he’d thought to find her fainted, or silently weeping, he was bound to disappointment, She heard his footsteps and opened her eyes. Their silvery-gray irises, finely rimmed with black, were alert and wildly defiant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk had been bound as a prisoner several times and knew how the body hurt when fettered. A cloth gag in the mouth was better than a leather strap, but it made the tongue dry as a desert and prone to swelling. If you fought the gag, it stretched the jaw hinges to an exquisite agony. There’d not been a whimper out of her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Half Breton, Fulk thought as he looked down at her. He was not fond of Bretons, who lived in hedgerows in their dank part of France and wore skins and furs like savages.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("De Bais had told him the girl had fought like a tiger and screamed like a virago while they chased her through half the keep. She had to be gagged so as not to deafen them all or further frighten the wits out of the greasy old monk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He hadn’t time to tend to her, Fulk allowed, as he eased in beside her and drew the blanket over both of them. He would, in his own time. At the moment he only wanted to rest his bones in a bed enjoy the softness of it, and dose his cold-ravaged eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He would see to his marital duties after that.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a few seconds he was asleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sometime in the night a peculiar smothered, choking sound woke him. With instincts honed by a soldier’s alertness, he came awake with a snap. Not moving, Fulk accustomed himself to the place where he lay.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a bed, he told himself. He’d been sleeping on the frozen ground for a month and had almost forgotten what a bed could feel like. Castle Morlaix, he remembered. He was surprised at the quick, pleased feeling that gave him. A castle. Now his.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Gradually, he became aware that an inert weight was rolled against him, bulky and curiously unyielding. The source of the muffled sounds.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Jesu, the woman!")])])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk jerked up in the bed, blankets scattering. The fire still flickered brightly, so he knew he had not slept that long, But the devil take it, this was his wedding night. How could he have done such a thing?")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A hasty examination told him the girl’s gag was still in place. Her eyes were closed. His heavier weight had pulled her down against him, and her face had been resting against the bedding. Trussed as she was, she couldn’t turn. It was possible she’d not been able to breathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk touched her arm where the sleeve of the woolen gown was pulled back. The flesh, although smooth, was cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He swore under his breath. This was not so good. If his bride died in her wedding bed, smothered or strangled by some misfortune with the cursed bedcoverings, King William would have his head. There were no witnesses to swear that this was not convenient murder but merely his own carelessness. Wincing, Fulk knew William the Bastard would have his new baron exquisitely tortured before he was hanged, and confiscate everything—castle, title, the troop of knights. With fumbling hands, he loosened the gag. His fate rested with this Welsh-Breton female who had turned unearthly pale.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The cloth ball rolled out of her mouth but her eyes did not open. Fulk rolled her on her stomach and worked at the knotted ropes binding her hands. He heard her moan.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Now then demoiselle, hark to me.” His voice was hoarse. “Are you alive?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("No answer. Her arms flapped listlessly as he lifted her to yank away the woolen surcoat. Was she breathing? Cursing himself a thousand times, Fulk bent his head to her pale lips, but could detect nothing. If she moaned she must still be alive, but he was not so sure. She could be breathing but dying; he had seen that on the battlefield.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He groaned aloud. It was Satan’s own devilment that here he was on his wedding night, trying to revive his bride, whom he had nearly murdered while sleeping with her. And, curse it, she was still a virgin! What a tale that would make to bring back to London.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hurriedly, Fulk laid the girl down and rubbed her hands and wrists. Little hands, delicate wrists, but cold as a corpse. He chafed them roughly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Should he massage her limbs also? he wondered. If her other extremities were as cold as her hands she was surely half-dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With more haste than skill, he shook her out of the bliaut and shift until he had her stripped to her underdrawers. After a second’s hesitation he peeled those off, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Holy Mary, Fulk thought, staring, so this was what he’d married. Lesneven’s spinster was the best thing by far he’d found in Castle Morlaix. Her form was exquisite, girlish: high, pretty breasts with thrusting pink, virginal nipples, a sweep of tiny waist and curving hips, a light ruff of dark pubic hair. Here was no aging, unweddable spinster, but a lovely maid, flawless silky skin, a body endowed with enchanting grace. Her long legs were perfection.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("While Fulk gazed she twitched. A shudder ran through her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hurriedly, Fulk slid down in the bed to send some of his own naked warmth into her. He rubbed wherever he could touch, regretting his sword hand was hard with calluses. With the other hand, he pulled the coverlet over them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For long moments he held his limp bride pressed against him as he did his best to massage some life back into her. He found her soft, rounded bottom and resisted the impulse to linger as he pummeled it thoroughly. Fulk ran his hand up her backbone and across the back of her neck, and could feel her flesh heating. When he raised himself up on one elbow he could see patches of fiery pink skin. Cursing his strength, he wondered if he would leave bruises.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Nor was he unaffected by all this, Fulk discovered. He’d become stiff as a poker.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her color was better bruised or not. The smooth ivory of her face was tinged now with pink. The tangled black fan of her hair spread across the bedcover, the shadow repeated in eyelashes against her cheeks. She had a narrow nose and full, pouting mouth—he couldn’t resist touching it with his finger. A strong, clear-cut jaw belied her faint look of a pretty child.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That jaw told the story. This was no maid but a woman. The Lady Alwyn was at least past her fifth and twentieth year. Age had not improved her disposition, either, Fulk knew; from the moment he’d seen her in the chapel she’d been a bundle of wildcat fury, barely restrained by the ropes. He could still hear her furious shriek echoing when he’d removed the gag.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He saw her eyelids flutter. Now he was certain she was alive, and would not die. His problems were just beginning.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She opened her eyes and looked up at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Bemused, Fulk regarded her, uncertain how unconscious she’d been while he’d roughly attempted to put some breath back into her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("What did she see? he wondered. He was a battle-worn knight two years shy of thirty, one of King William’s loyal captains now suddenly made a baron and given her castle by royal decree. To her he would appear a hard-eyed stranger with short-cropped russet hair, not as handsome as Geoffrey de Bocage, to whom women always gravitated, but already aroused and wanting her. Lying naked beside her in her bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was for him to make the best of: it he could not stay idle there all night. Softly, he lifted his hand and cupped one small, smooth breast. He saw her eyes go wide as his fingertip stroked the hard bud of her nipple. She jerked, not taking her eyes from his, and grabbed at his arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ah, he thought, it was not going to be as bad as he’d thought. At least she had not screamed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We are married,” he told her. It was not the most intelligent of remarks, but it got to the heart of the matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He saw her bite her lips. Her hands rose between them, ready to do battle, and the corners of her mouth turned down. Before she could open it to shriek, Fulk clamped his hand over her lips. Not gently. Almost without thinking, he raised the other hand, making a fist.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was impressive, the clenched hand held up before her face: glistening sword scars ran in grooves across his knuckles, and the thumb was bent where it had been broken by a blow from a mace in the Avranches. Her eyes twisted, mutely, to look at it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk said nothing, nor did he lower his fist. Let her think it over.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After long moments, he saw her close her eyes. Then a drop, a tear, appeared glistening under black lashes, and slowly ran down the side of her face. She went limp under him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Come, it will not be all that bad,” he told her. He regretted the gesture, but he would not endure more defiance and screaming; he was too damnably tired. And the truth of the matter was that he was already thinking about what was to come. Almost unwillingly, a hot rush of excitement flared in his vitals and made him painfully harder.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slowly, he bent his head and put his mouth on hers, careful to draw back at once if she bit. She trembled, but did not resist, her lips tightly closed. He moved his mouth from side to side until the pressure made first the lower lip, then the upper, open to him. Her breath was sweet, and so was her taste. Fulk found himself suddenly flushed, and knew it was not the Welsh beer he had drunk. He had already decided he would have to be gentle with her if she remained calm. After all, it was her first time. But he had not counted on his own lust nearly getting the better of him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When he nibbled her soft little breasts she made a gasping sound and tried to pull his head away, her fingers locked in his hair. That inflamed, and surprised him, as he had not been that long without a woman. Ah, but she was sweet, "), _c('i', [_vm._v("sweet")]), _vm._v("! More hurriedly than he’d planned, his hand crept between her legs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She fought him with fluttering, protesting hands, French and Welsh words mixed together breathlessly. Her voice was husky.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Shhh,” he told her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He kissed her again, and this too was more than expected, The little mouth opened, resigned, and let him do what he wanted. Now it was he who was breathless. Worse, he could not tear himself away from the kiss. It devoured him. In return he devoured, her. He broke for a breath, then went back again. He was amazed that the Welsh girl so aroused him. Still a virgin, she was doing absolutely nothing. She didn’t know a thing, and he was about to burst. Her hand brushed his bare hip and he shuddered, violently.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What?” she cried.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk pulled back. He shook his head to clear it. He was not going to be able to do his duty properly if he kept this up. Was it the warmth, the bed, after being so long in the cold? No, it was more her smooth, silky body, her wary, expectant trembling. He’d needed a woman more than he thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Breathing hard, Fulk looked down into her face. Her expression was that of one bravely facing an unknown terror. He almost laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Demoiselle—” She was no longer a demoiselle, he\nreminded himself; she was his wife. He would fix that in a moment. “Madame, do you know what I\nam about to do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She didn’t answer. Saying a prayer for her instruction by someone, sometime, his fingers stroked the tiny bud in the warm, fleshy cleft between he legs. He needed her wet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her expression became even more abstracted. Still she said nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My lady?” Fulk’s need was pressing. It fairly shouted at him, a pain that was near to torture. But his bride’s eyes were fixed, unseeing, on some point over his shoulder. He kissed her again, his hands stroking her belly, her smooth legs. He kissed her breasts with growing intensity.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Stop,” she breathed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, no.” His words were hurried. “I need to make\nyou my wife.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Not for King William, now, but for himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He lifted his body over her, his hands eager for her satiny flesh. It was not going to be too bad for her; he’d promised himself he would see to that. He inserted one finger into the tight, slippery channel of her femininity and felt her go rigid. He stopped for long minutes to let her become accustomed to it. He knew he was going to hurt her and cursed himself for the impossibility of it all. Abruptly, Fulk sat back on his heels. He saw her avert her eyes. Well, he was as aroused as a rutting goat; somehow she would have to accommodate him. Gently, he pushed her legs apart with both hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Put your arms about my neck,” he told her as he lowered himself to her. He did not know whether she did or not, for in the next moment he thrust into her in haste, felt the hot tightness, and the barrier break.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His mind afire, Fulk thrust all the way in and held himself still. He couldn’t think. God’s wounds, but this was tearing him apart! He would never deflower another virgin as long as he lived. Who would have thought it would be this way?")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When he moved, the girl sobbed, softly. He held himself back, gritting his teeth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Surely he’d imagined it, when she moved. He could only think, with the part of his mind that was still working, that she didn’t know what she was doing. Shuddering, her eyes tightly closed, she squirmed against him. Fulk held himself stiffly, half blinded by sweat and passion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Now she put her hands about his neck, as if clinging to something that could save her. He heard her gasp. He was certain that she did not know what she was doing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Holy Cross, neither did he.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He imagined his pounding hurt her, but it was her fault, as she kept moving with clumsy uncertainty. He felt himself buck, lifting her, all his good intentions thrown to the winds. They slid to the edge of the bed. He held her in an iron grip, dimly fighting not to lose control.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He reached his peak in a roaring red haze. If he hadn’t thrust his foot over the edge of the bed and braced himself they would have fallen out of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When it was over he collapsed against her, groaning and struggling for breath. He didn’t know if she had reached her peak or not. Since she’d been a virgin, probably not. It occurred to him that he didn’t know why he was worrying about it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fulk drew her up against him and held her while he fought for breath. Lustful minx. She’d put her arms around him and, for a few awkward seconds at the last, almost matched his frenzy. He found it beyond belief.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He wondered if she would be ready to take him again that night. Would she be too sore? When she had calmed somewhat, he would find out. Then he was reminded of the marital bedsheet, the proof of the bloodstains.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He lay back against the bed, holding the still-trembling girl in his arms, recalling the deficiencies of his marrying. A cursed brutal affair, there had not even been a wedding feast, and virtually no witnesses—certainly no one but his own knights to testify in the morning if her virginal stains were displayed. The thought repelled him. He’d be damned if he’d do that; it was none of his knights’ affair.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then he thought: perhaps he should bundle up the coverlet where they lay and send it back to William.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He tried not to laugh. Still struggling to get his breath, he stroked the top of the girl’s head as she lay beside him. He’d be on his way to Chirk before dawn, to rout out Hereford’s rebels. Now was not the time to fret over what had or had not been done—the act was out of the way and it was legal. The deed was accomplished.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Wife")]), _vm._v(". The woman beside him was his wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("God’s bones, last month, last week, "), _c('i', [_vm._v("yesterday")]), _vm._v("—he hadn’t even wanted to be married.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1331d0c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 75
// module chunks = 0